import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Send, Sparkles, Loader2 } from "lucide-react";

export function AIPostDialog({ open, onOpenChange, saving, schedule, onGenerate, onPublish }) {
  const [aiStyle, setAiStyle] = useState("promotional");
  const [generatedContent, setGeneratedContent] = useState(null);
  const [aiGenerating, setAiGenerating] = useState(false);

  const handleClose = (isOpen) => {
    if (!isOpen) setGeneratedContent(null);
    onOpenChange(isOpen);
  };

  const handleGenerate = async () => {
    setAiGenerating(true);
    const result = await onGenerate({ aiStyle, restaurantInfo: schedule?.restaurant_info });
    if (result) setGeneratedContent(result);
    setAiGenerating(false);
  };

  const handlePublish = () => {
    onPublish({ aiStyle, restaurantInfo: schedule?.restaurant_info }, () => {
      setGeneratedContent(null);
      onOpenChange(false);
    });
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-purple-600" />
            Criar Post com IA
          </DialogTitle>
          <DialogDescription>
            A IA vai gerar um post automaticamente baseado nas informações do seu restaurante
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <label className="text-xs font-medium text-muted-foreground">Estilo do Conteúdo</label>
            <Select value={aiStyle} onValueChange={setAiStyle}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="promotional">Promocional (ofertas, novidades)</SelectItem>
                <SelectItem value="educational">Educativo (dicas, curiosidades)</SelectItem>
                <SelectItem value="engagement">Engajamento (perguntas, enquetes)</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {!generatedContent ? (
            <Button
              onClick={handleGenerate}
              disabled={aiGenerating}
              className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700"
            >
              {aiGenerating ? (
                <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Gerando com IA...</>
              ) : (
                <><Sparkles className="w-4 h-4 mr-2" />Gerar Conteúdo</>
              )}
            </Button>
          ) : (
            <div className="space-y-3">
              <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                <p className="text-sm font-medium mb-2">Conteúdo Gerado:</p>
                <p className="text-sm whitespace-pre-wrap">{generatedContent.text}</p>
                <p className="text-xs text-purple-600 mt-2">{generatedContent.hashtags}</p>
              </div>
              <div className="flex gap-2">
                <Button
                  variant="outline"
                  onClick={() => { setGeneratedContent(null); handleGenerate(); }}
                  disabled={aiGenerating}
                  className="flex-1"
                >
                  <Sparkles className="w-4 h-4 mr-1" />
                  Gerar Outro
                </Button>
                <Button
                  onClick={handlePublish}
                  disabled={saving}
                  className="flex-1 bg-gradient-to-r from-pink-600 to-purple-600"
                >
                  {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />}
                  Publicar
                </Button>
              </div>
            </div>
          )}

          <p className="text-xs text-muted-foreground text-center">
            Dica: Configure as informações do seu restaurante no Agendamento para posts mais personalizados
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
